import { isGroceryBasketType, isMealboxBasketType } from "@chef/helpers";
import { isEmptyArray } from "@chef/utils/array";

import { CalendarQuery } from "../graphql/generated";

export const getBasketDataFromCalendar = (args: {
  calendar?: CalendarQuery["calendar"];
  week: number;
  year: number;
}) => {
  const { calendar, week, year } = args;

  const data = calendar?.find((c) => c.week === week && c.year === year);

  if (!data) {
    return null;
  }

  const _baskets = data.baskets.filter(
    (b) => b.week === week && b.year === year,
  );

  if (isEmptyArray(_baskets)) {
    return null;
  }

  const mealboxBasket = _baskets.find(isMealboxBasketType) ?? null;
  const groceryBasket = _baskets.find(isGroceryBasketType) ?? null;

  const baskets = {
    mealboxBasket,
    groceryBasket,
  };

  return baskets;
};

export const getIsBeforeStartDateFromCalendar = (args: {
  calendar: CalendarQuery["calendar"];
  week: number;
  year: number;
}) => {
  const { calendar, week, year } = args;

  const data = calendar.find((c) => {
    return c.week === week && c.year === year;
  });

  if (!data) {
    return null;
  }

  return data.isBeforeStartDateWeek;
};

export const getNextDeliveryFromCalendar = (args: {
  calendar: CalendarQuery["calendar"];
  notRequiredDelivery?: true;
}) => {
  const { calendar, notRequiredDelivery } = args;

  for (const c of calendar) {
    if (c.isBeforeStartDateWeek) {
      continue;
    }

    for (const basket of c.baskets) {
      if (basket.shippingDetails.hasDelivery || notRequiredDelivery) {
        return c;
      }
    }
  }

  return null;
};

export const getWeeklyTimeblockDataFromCalendar = (args: {
  calendar: CalendarQuery["calendar"];
  week: number;
  year: number;
}) => {
  const { calendar, week, year } = args;

  const baskets = getBasketDataFromCalendar({
    calendar,
    week,
    year,
  });

  if (!baskets?.mealboxBasket) {
    return null;
  }

  // Use mealboxBasket if available, otherwise fallback to groceryBasket
  const shippingDetails =
    baskets.mealboxBasket?.shippingDetails ??
    baskets.groceryBasket?.shippingDetails;

  return shippingDetails?.plannedDeliveryInformation || null;
};

export const getCurrentWeekDataAndBasketFromCalendar = (args: {
  calendar: CalendarQuery["calendar"];
  week: number;
  year: number;
}) => {
  const { calendar, week, year } = args;

  const calendarWeek = calendar.find((c) => c.week === week && c.year === year);
  if (!calendarWeek) {
    return null;
  }

  const baskets = getBasketDataFromCalendar({ calendar, week, year });

  if (!baskets) {
    return null;
  }

  const { baskets: _, ...restData } = calendarWeek;
  const currentWeekData = {
    ...restData,
    mealboxBasket: baskets.mealboxBasket,
    groceryBasket: baskets.groceryBasket,
  };
  return currentWeekData;
};
